import _ from 'underscore';

export const LocationCriterionTypes = ['Location', 'Radius', 'LocationIntent'];
export const AudienceCriterionTypes = ['CompanyName', 'Industry', 'JobFunction', 'JobTitle', 'JobSeniority'];
export const AgeCriterionTypes = ['Age'];
export const GenderCriterionTypes = ['Gender'];

export const filterCriterionsByType = (criterions, types) => _.filter(criterions, c => types.includes(c.Criterion.Type));
